import { wrapperFor } from './gateway';

/**
 * The chat's calls on production: the server signs in with the key Odin issued once.
 *
 * This used to be an axios client carrying that key, and it also wrote the key into
 * sessionStorage. Both put it in front of every visitor (WEB-1880); neither is needed,
 * because the websocket identifies itself with the chat's own session id.
 */
const API = wrapperFor('token');

export default API;
